import {arrayToSet, filterMapByKeys} from '../../../atUtils'
import * as EntitiesActionTypes from '../../../entities/actionTypes'
import {CLOSE_ALL_PANELS} from '../common/actionTypes'

export default function({
    actionTypes: {
        PANEL_OPEN,
        PANEL_CLOSE,
        LOADED_SET,
        LOADING_SET,
        USER_ID_SET,
        PANEL_TAB_SET,
        TASK_IDS_SET,
        PROJECT_IDS_SET,
        CUSTOMER_IDS_SET,
        MANAGE_TASK_IDS_SET,
        MANAGE_PROJECT_IDS_SET,
        MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET,
        MANAGE_CUSTOMER_IDS_SET,
        MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET,
        TASK_TAB_LOADED,
        PROJECT_TAB_LOADED,
        CUSTOMER_TAB_LOADED,
        USER_COUNTERS_SET,
        PANEL_SEARCH_STRING_SET,
        PANEL_SEARCH_OPEN_SET,
        SET_IS_SHOW_ARCHIVE_ENTITIES,
    }
}) {
    return {
        initialState: {
            userId: null,
            tab: null,

            taskIds: [],
            projectIds: [],
            customerIds: [],

            manageCptIds: {
                customerIds: {},
                customerIdsExcludingSelf: {},
                projectIds: {},
                projectIdsExcludingSelf: {},
                taskIds: {},
            },

            isLoadedTaskTab: false,
            isLoadedProjectTab: false,
            isLoadedCustomerTab: false,

            userCounters: {
                customers: 0,
                projects: 0,
                tasks: 0,
            },

            searchString: '',
            searchOpen: false,
            isShowArchivedEntities: false,

            loading: false,
            loaded: false,
        },
        handlers: {
            [PANEL_OPEN]: (state, {payload: {userId, tab}}) => ({
                ...state,
                userId,
                tab,
                loaded: false,
                isLoadedCustomerTab: false,
                isLoadedProjectTab: false,
                isShowArchivedEntities: false,
                isLoadedTaskTab: false,
                searchString: null,
                searchOpen: false,
            }),
            [PANEL_CLOSE]: (state) => ({
                ...state,
                userId: null,
                tab: null,
                loading: false,
                loaded: false,
                isLoadedCustomerTab: false,
                isLoadedProjectTab: false,
                isLoadedTaskTab: false,
                searchString: null,
                searchOpen: false,
            }),
            [LOADED_SET]: (state, {payload: loaded}) => ({
                ...state,
                loaded,
            }),
            [LOADING_SET]: (state, {payload: loading}) => ({
                ...state,
                loading,
            }),
            [USER_ID_SET]: (state, {payload: userId}) => ({
                ...state,
                userId: userId,
            }),
            [PANEL_TAB_SET]: (state, {payload: tab}) => ({
                ...state,
                tab: tab,
                isShowArchivedEntities: false,
            }),
            [TASK_IDS_SET]: (state, {payload: taskIds}) => ({
                ...state,
                taskIds: taskIds,
            }),
            [PROJECT_IDS_SET]: (state, {payload: projectIds}) => ({
                ...state,
                projectIds: projectIds,
            }),
            [CUSTOMER_IDS_SET]: (state, {payload: customerIds}) => ({
                ...state,
                customerIds: customerIds,
            }),
            [MANAGE_TASK_IDS_SET]: (state, {payload: taskIds}) => ({
                ...state,
                manageCptIds: { ...state.manageCptIds, ...{taskIds: taskIds} },
            }),
            [MANAGE_PROJECT_IDS_SET]: (state, {payload: projectIds}) => ({
                ...state,
                manageCptIds: { ...state.manageCptIds, projectIds: projectIds },
            }),
            [MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET]: (state, {payload: projectIdsExcludingSelf}) => ({
                ...state,
                manageCptIds: { ...state.manageCptIds, projectIdsExcludingSelf: projectIdsExcludingSelf },
            }),
            [MANAGE_CUSTOMER_IDS_SET]: (state, {payload: customerIds}) => ({
                ...state,
                manageCptIds: { ...state.manageCptIds, customerIds: customerIds },
            }),
            [MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET]: (state, {payload: customerIdsExcludingSelf}) => ({
                ...state,
                manageCptIds: { ...state.manageCptIds, customerIdsExcludingSelf: customerIdsExcludingSelf },
            }),
            [TASK_TAB_LOADED]: (state, {payload: loaded}) => ({
                ...state,
                isLoadedTaskTab: loaded,
            }),
            [PROJECT_TAB_LOADED]: (state, {payload: loaded}) => ({
                ...state,
                isLoadedProjectTab: loaded,
            }),
            [CUSTOMER_TAB_LOADED]: (state, {payload: loaded}) => ({
                ...state,
                isLoadedCustomerTab: loaded,
            }),
            [USER_COUNTERS_SET]: (state, {payload: userCounters}) => ({
                ...state,
                userCounters: userCounters,
            }),
            [PANEL_SEARCH_STRING_SET]: (state, {payload: text}) => ({
                ...state,
                searchString: text,
            }),
            [PANEL_SEARCH_OPEN_SET]: (state, {payload: open}) => ({
                ...state,
                searchOpen: open
            }),
            [EntitiesActionTypes.CUSTOMERS_REMOVE]: (state, {payload: customerIds}) => ({
                ...state,
                customerIds: state.customerIds.filter(tId => !arrayToSet(customerIds)[tId]),
                manageCptIds: {
                    ...state.manageCptIds,
                    customerIds: filterMapByKeys(state.manageCptIds.customerIds, customerIds),
                    customerIdsExcludingSelf: filterMapByKeys(state.manageCptIds.customerIdsExcludingSelf, customerIds),
                },
            }),
            [EntitiesActionTypes.PROJECTS_REMOVE]: (state, {payload: projectIds}) => ({
                ...state,
                projectIds: state.projectIds.filter(tId => !arrayToSet(projectIds)[tId]),
                manageCptIds: {
                    ...state.manageCptIds,
                    projectIds: filterMapByKeys(state.manageCptIds.projectIds, projectIds),
                    projectIdsExcludingSelf: filterMapByKeys(state.manageCptIds.projectIdsExcludingSelf, projectIds),
                },
            }),
            [EntitiesActionTypes.TASKS_REMOVE]: (state, {payload: taskIds}) => ({
                ...state,
                taskIds: state.taskIds.filter(tId => !arrayToSet(taskIds)[tId]),
                manageCptIds: {
                    ...state.manageCptIds,
                    taskIds: filterMapByKeys(state.manageCptIds.taskIds, taskIds)
                },
            }),
            [SET_IS_SHOW_ARCHIVE_ENTITIES]: (state, {payload: value}) => ({
                ...state,
                isShowArchivedEntities: value,
            }),
            [CLOSE_ALL_PANELS]: (state) => ({
                ...state,
                userId: null,
                tab: null,

                taskIds: [],
                projectIds: [],
                customerIds: [],

                manageCptIds: {
                    customerIds: {},
                    customerIdsExcludingSelf: {},
                    projectIds: {},
                    projectIdsExcludingSelf: {},
                    taskIds: {},
                },

                isLoadedTaskTab: false,
                isLoadedProjectTab: false,
                isLoadedCustomerTab: false,

                userCounters: {
                    customers: 0,
                    projects: 0,
                    tasks: 0,
                },

                isShowArchivedEntities: false,

                loading: false,
                loaded: false,
                searchString: null,
                searchOpen: false,
            }),
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsPanelTab/reducerGenerator.js